module.exports = __webpack_public_path__ + "static/img/league.b380edf.png";


//////////////////
// WEBPACK FOOTER
// ./static/footer/league.png
// module id = djgx
// module chunks = 16